import React from 'react';
import Marquee from "react-fast-marquee";
import './MarqueeAbout.sass'
import hhmi from '../assets/images/hhmi.png'
import mlvisualize from '../assets/images/mlvisualize.png'
import columbia from '../assets/images/columbia.png'
import brandeis from '../assets/images/brandeis.png'
import stmaur from '../assets/images/stmaur.png'
import markovai from '../assets/images/markov.png'
import micron from '../assets/images/micron.png'
import ni from '../assets/images/ni.png'
import teamLab from '../assets/images/teamLab.png'
import influ from '../assets/images/influ.jpeg'

function MarqueeAbout() {
    return (
        <Marquee
            pauseOnHover
            gradient={false}
        >
            <img src={hhmi} className={'marquee_about__child marquee_about__img'} alt={'logo of hhmi'} />
            <img src={mlvisualize} className={'marquee_about__child marquee_about__img'} alt={'logo of mlvisualize'} />
            <div className="marquee_about__child">Resera Capital</div>
            <img src={markovai} className={'marquee_about__child marquee_about__img'} alt={'logo of markov ai'} />
            <img src={columbia} className={'marquee_about__child marquee_about__img'} alt={'logo of columbia'} />
            <img src={micron} className={'marquee_about__child marquee_about__img'} alt={'logo of micron'} />
            <img src={ni} className={'marquee_about__child marquee_about__img'} alt={'logo of national instruments'} />
            <img src={teamLab} className={'marquee_about__child marquee_about__img'} alt={'logo of teamLab'} />
            <img src={brandeis} className={'marquee_about__child marquee_about__img'} alt={'logo of brandeis'} />
            <img src={influ} className={'marquee_about__child marquee_about__img'} alt={'logo of influ'} />
            <img src={stmaur} className={'marquee_about__child marquee_about__img'} alt={'logo of stmaur'} />
        </Marquee>
    );
}

export default MarqueeAbout;